import { useEffect, useState } from "react";

const navLinks = [
  { id: "hot", label: "今日热榜", icon: "ri-fire-line" },
  { id: "feed", label: "新瓜速递", icon: "ri-flashlight-line" },
  { id: "topics", label: "热议话题", icon: "ri-chat-3-line" },
  { id: "special", label: "深度专题", icon: "ri-focus-3-line" },
  { id: "about", label: "关于吃瓜51", icon: "ri-quill-pen-line" },
  { id: "faq", label: "常见问题", icon: "ri-question-line" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [dateStr, setDateStr] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const now = new Date();
    const week = ["日", "一", "二", "三", "四", "五", "六"];
    setDateStr(
      `${now.getMonth() + 1}月${now.getDate()}日 · 周${week[now.getDay()]}`
    );
  }, []);

  const handleAnchor = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className={`transition-all duration-300 ${scrolled ? "bg-background-50/90 shadow-soft backdrop-blur-md" : "bg-transparent"}`}>
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
          <a
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="group flex items-center gap-2.5"
            aria-label="吃瓜51 首页"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 shadow-soft transition-transform group-hover:scale-105">
              <i className="ri-fire-fill text-xl" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                吃瓜51
              </span>
              <span className="mt-0.5 text-[10px] font-medium tracking-widest text-primary-600">
                今日新瓜速递
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navLinks.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => handleAnchor(link.id)}
                className="group flex items-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
              >
                <i className={`${link.icon} text-base text-primary-500 transition-transform group-hover:-translate-y-0.5`} />
                {link.label}
              </button>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-800">
              <i className="ri-calendar-2-line" />
              {dateStr}
            </span>
            <button
              type="button"
              onClick={() => handleAnchor("subscribe")}
              className="flex items-center gap-1.5 whitespace-nowrap rounded-lg bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-all hover:bg-primary-600 active:scale-95"
            >
              <i className="ri-send-plane-line" />
              订阅新瓜
            </button>
          </div>

          <button
            type="button"
            className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-900 md:hidden"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 pb-4 pt-2 backdrop-blur-md md:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => handleAnchor(link.id)}
                className="flex items-center gap-3 rounded-lg px-3 py-3 text-left text-base font-medium text-foreground-800 transition-colors hover:bg-secondary-100"
              >
                <i className={`${link.icon} text-lg text-primary-500`} />
                {link.label}
              </button>
            ))}
            <button
              type="button"
              onClick={() => handleAnchor("subscribe")}
              className="mt-2 flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-4 py-3 text-base font-semibold text-background-50"
            >
              <i className="ri-send-plane-line" />
              订阅新瓜速递
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}